import React from 'react'
import PageNotFound from '../components/commonComponents/PageNotFound'

const PageNotFoundPage = () => {
  return (
    <PageNotFound/>
  )
}

export default PageNotFoundPage